<template>
  <header class="searchHeader sort">
    <h1 v-if="title"><span class="word">”{{ title }}”</span>の検索結果</h1>
    <h1 v-else>検索結果</h1>
    <div class="found">
      <p class="count"><span class="num">{{ total }}</span>件</p>
    </div>
    <div class="filters">
      <form class="actions" :action="link.search">
        <div class="icon chip summary" @click.self="togglePopup('summary')">
          <div class="popup sort summary" v-if="popup === 'summary'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title summary">並び替えとフィルター</h2>
              <ul class="summary-list">
                <li class="summary-list-item">
                  <label for="summary-sort">並び替え</label>
                  <div class="radio-container">
                    <label v-for="(sort, key) in sorts" :key="key">
                      <input type="radio" name="sort" v-model="filters.sort_by" :value="sort.val">
                      {{ sort.name }}
                    </label>
                  </div>
                </li>
                <li class="summary-list-item">
                  <label for="summary-coupon">クーポン</label>
                  <div class="radio-container">
                    <label>
                      <input type="radio" name="coupon" v-model="filters.coupon" :value="''">
                      指定なし
                    </label>
                    <label>
                      <input type="radio" name="coupon" v-model="filters.coupon" :value="true">
                      クーポンあり
                    </label>
                    <label>
                      <input type="radio" name="coupon" v-model="filters.coupon" :value="false">
                      クーポンなし
                    </label>
                  </div>
                </li>
                <li class="summary-list-item">
                  <label for="summary-budget">予算</label>
                  <div class="summary-list-item-select picker budget">
                    <scroll-picker
                      :options="budgetOptions"
                      v-model="filters.budget"
                    />
                  </div>
                  <!-- <span class="rateTime">※◯月◯日◯時為替反映</span> -->
                </li>
                <li class="summary-list-item">
                  <label for="summary-other">こだわり</label>
                  <ul class="other-list">
                    <li
                      v-for="(tag, key) in tags" :key="key"
                      :class="`other-list-item ${filters.other.includes(Number(tag.id)) ? 'selected' : ''}`"
                      @click="summaryAction('other', otherId=Number(tag.id))"
                    >
                      {{ tag.name }}
                    </li>
                  </ul>
                </li>
                <li @click="summaryAction('genre')" class="summary-list-item">
                  <label for="summary-genre">ジャンル</label>
                  <div class="summary-list-item-select arrow-right">
                    <div :class="`val ${filters.genre.length > 0 ? 'selected' : ''}`" id="summaryGenre">
                      {{ summaryIsVal('genre')}}
                    </div>
                  </div>
                </li>
                <li @click="summaryAction('area')" class="summary-list-item">
                  <label for="summary-area">エリア</label>
                  <div class="summary-list-item-select arrow-right">
                    <div :class="`val ${filters.area.length > 0 ? 'selected' : ''}`" id="summaryArea">
                      {{ summaryIsVal('area')}}
                    </div>
                  </div>
                </li>
                <li class="summary-list-item">
                  <label for="summary-distance">距離</label>
                  <div v-if="!geolocationPositionError" class="summary-list-item-select picker distance">
                    <scroll-picker
                      :options="distanceOptions"
                      v-model="filters.distance"
                    />
                  </div>
                  <p v-else>位置情報を取得出来ませんでした。距離を設定する場合は位置情報サービスをオンにしてください。</p>
                </li>
                <li class="summary-list-item">
                  <label for="summary-selected">現在指定している条件</label>
                  <p>{{ summaryIsVal('selected') }}</p>
                </li>
              </ul>
              <div class="button-container">
                <div @click="isClearModal = true" class="button-clear">クリア</div>
                <div class="button" @click.stop="search()">適用する</div>
              </div>
            </div>
          </div>
        </div>
        <div class="chip selectable sort" :class="{ 'selected': filters.sort_by }" @click.self="togglePopup('sort')">
          {{ chipTitle('sort') }}
          <div class="popup sort" v-if="popup === 'sort'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title">並べ替え</h2>
              <label v-for="(sort, key) in sorts" :key="key">
                <input type="radio" name="sort_by" v-model="filters.sort_by" :value="sort.val">
                {{ sort.name }}
              </label>
              <div class="button" @click.stop="search()">適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable sort" :class="{ 'selected': filters.coupon !== '' }" @click.self="togglePopup('coupon')">
          {{ chipTitle('coupon') }}
          <div class="popup sort" v-if="popup === 'coupon'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title">クーポン</h2>
              <label>
                <input type="radio" name="coupon" v-model="filters.coupon" :value="''">
                指定なし
              </label>
              <label>
                <input type="radio" name="coupon" v-model="filters.coupon" :value="true">
                クーポンあり
              </label>
              <label>
                <input type="radio" name="coupon" v-model="filters.coupon" :value="false">
                クーポンなし
              </label>
              <div class="button" @click.stop="search()">適用する</div>
            </div>
          </div>
        </div>
        <div
          :class="`chip selectable budget popupPicker ${
            filters.budget[0] ||
            filters.budget[1] ||
            filters.budget[2] ? 'selected' : ''
          }`"
          @click.self="togglePopup('budget')"
        >
          {{ chipTitle('budget') }}
          <div class="popup sort" v-if="popup === 'budget'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title">予算</h2>
              <scroll-picker
                :options="budgetOptions"
                v-model="filters.budget"
              />
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable other" :class="{ 'selected': filters.other.length !== 0 }" @click.self="togglePopup('other')">
          {{ chipTitle('other') }}
          <div class="popup sort" v-if="popup === 'other'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title"> こだわり </h2>
              <label v-for="(tag, key) in tags" :key="key">
                <input type="checkbox" name="other" v-model="filters.other" :value="tag.id">
                {{ tag.name }}
              </label>
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable genre" :class="{ 'selected': filters.genre.length !== 0 }" @click.self="togglePopup('genre')">
          {{ chipTitle('genre') }}
          <div class="popup sort" v-if="popup === 'genre' || popup === 'genreSummary'">
            <div class="content genre" v-click-outside="onClickOutside">
              <h2 :class="`title ${summaryGroupTitle ? 'summary' : ''}`">
                <img
                  v-if="popup === 'genreSummary'"
                  @click.self="summaryAction('summaryGenrePopup')"
                  src="/assets/img/common/arrow_left_blue--head.svg"
                  class="isSummary"
                />
                ジャンル
              </h2>
              <div v-for="(category, categoryIndex) in shopCategory" :key="categoryIndex" class="category">
                <span class="category-title">{{ category.name }}</span>
                <label v-for="(genre, genreIndex) in category.children" :key="genreIndex">
                  <input type="checkbox" name="genre" v-model="filters.genre" :value="genre.id">
                  {{ genre.name }}
                </label>
              </div>
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="chip selectable area" :class="{ 'selected': filters.area.length !== 0 }" @click.self="togglePopup('area')">
          {{ chipTitle('area') }}
          <div class="popup sort" v-if="popup === 'area'  || popup === 'areaSummary'">
            <div class="content area" v-click-outside="onClickOutside">
              <h2 :class="`title ${summaryGroupTitle ? 'summary' : ''}`">
                <img
                  v-if="popup === 'areaSummary'"
                  @click.self="summaryAction('summaryAreaPopup')"
                  src="/assets/img/common/arrow_left_blue--head.svg"
                  class="isSummary"
                />
                エリア
              </h2>
              <div v-for="(category, categoryKey) in shopArea" :key="categoryKey" class="category">
                <span class="category-title">{{ category.name }}</span>
                <label v-for="(area, areaKey) in category.children" :key="areaKey">
                  <input type="checkbox" name="area" v-model="filters.area" :value="area.id">
                  {{ area.name }}
                </label>
              </div>
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div
          :class="`chip selectable distance popupPicker
          ${filters.distance[0] && !geolocationPositionError ? 'selected' : ''}
          ${geolocationPositionError ? 'notSelect' : ''}
          `"
          @click.self="togglePopup('distance')"
        >
          {{ chipTitle('distance') }}
          <div class="popup sort" v-if="popup === 'distance'">
            <div class="content" v-click-outside="onClickOutside">
              <h2 class="title">距離</h2>
              <scroll-picker
                :options="distanceOptions"
                v-model="filters.distance"
              />
              <div class="button" @click.stop="search()"> 適用する</div>
            </div>
          </div>
        </div>
        <div class="clear" @click="isClearModal = true">クリア</div>
        <Transition name="clear-modal" @before-enter="beforeEnter" @after-leave="afterLeave">
          <div v-if="isClearModal" class="clear-modal" @click.self="isClearModal = false">
            <div class="box">
              <p>設定している検索条件を<br/>
                すべてクリアしますか？</p>
                <div class="clear" @click="clear()">すべてクリア</div>
                <div class="cancel" @click="isClearModal = false">キャンセル</div>
            </div>
          </div>
        </Transition>
      </form>
    </div>
  </header>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
import ScrollPicker from 'vue3-scroll-picker'

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    total: {
      type: Number,
      required: true
    },
    params: {
      type: Object,
      required: false
    },
    link: {
      type: String,
      required: true
    },
    shopCategory: {
      type: Array,
      required: true,
    },
    shopArea: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  components: {
    ScrollPicker,
  },
  data() {
    return {
      filters: {
        sort_by: 'popular_coupon',
        coupon: '',
        budget: ['', ''],
        genre: [],
        other: [],
        area: [],
        distance: [''],
      },
      popup: null,
      isClearModal: false,
      summaryGroupTitle: false,
      filtersComparison: {},
      sortOptions: [
        {
          name: '人気のクーポン順', // todo 表記変更
          val: 'popular_coupon'
        },
        // {
        //   name: 'ランキング順',
        //   val: 'ranking'
        // },
        {
          name: 'お気に入りが多い順',
          val: 'favorite'
        },
        {
          name: '口コミが多い順',
          val: 'reviews'
        },
        {
          name: '近い順',
          val: 'distance_close'
        },
      ],
      budgetOptions: [
        // [
        //   {
        //     label: "指定なし",
        //     value: ""
        //   },
        //   {
        //     label: "昼",
        //     value: "day"
        //   },
        //   {
        //     label: "夜",
        //     value: "night"
        //   },
        // ],
        [
          {
            label: "下限なし",
            value: ""
          },
          {
            label: "$10",
            value: 10
          },
          {
            label: "$20",
            value: 20
          },
          {
            label: "$30",
            value: 30
          },
          {
            label: "$40",
            value: 40
          },
          {
            label: "$50",
            value: 50
          },
          {
            label: "$60",
            value: 60
          },
          {
            label: "$80",
            value: 80
          },
          {
            label: "$100",
            value: 100
          },
          {
            label: "$150",
            value: 150
          },
          {
            label: "$200",
            value: 200
          },
          {
            label: "$300",
            value: 300
          },
          {
            label: "$400",
            value: 400
          },
          {
            label: "$500",
            value: 500
          },
          {
            label: "$600",
            value: 600
          },
          {
            label: "$800",
            value: 800
          },
          {
            label: "$1000",
            value: 1000
          },
        ],
        [
          {
            label: "$10",
            value: 10
          },
          {
            label: "$20",
            value: 20
          },
          {
            label: "$30",
            value: 30
          },
          {
            label: "$40",
            value: 40
          },
          {
            label: "$50",
            value: 50
          },
          {
            label: "$60",
            value: 60
          },
          {
            label: "$80",
            value: 80
          },
          {
            label: "$100",
            value: 100
          },
          {
            label: "$150",
            value: 150
          },
          {
            label: "$200",
            value: 200
          },
          {
            label: "$300",
            value: 300
          },
          {
            label: "$400",
            value: 400
          },
          {
            label: "$500",
            value: 500
          },
          {
            label: "$600",
            value: 600
          },
          {
            label: "$800",
            value: 800
          },
          {
            label: "$1000",
            value: 1000
          },
          {
            label: "上限なし",
            value: ""
          },
        ],
      ],
      distanceOptions: [
        [
          {
            label: "指定なし",
            value: ""
          },
          {
            label: "100m",
            value: 100
          },
          {
            label: "300m",
            value: 300
          },
          {
            label: "500m",
            value: 500
          },
          {
            label: "800m",
            value: 800
          },
          {
            label: "1km",
            value: 1000
          },
          {
            label: "2km",
            value: 2000
          },
          {
            label: "3km",
            value: 3000
          },
        ]
      ],
      geolocationAvailable: null,
      geolocationPosition: null,
      geolocationPositionError: null,
    }
  },
  watch: {
    popup(newVal, oldVal) {
      if (oldVal === 'summary' && (newVal === 'genreSummary' || newVal === 'areaSummary')) {
        this.summaryGroupTitle = true
      } else {
        this.summaryGroupTitle = false
      }
    }
  },
  computed: {
    geolocation(){
      return navigator.geolocation
    },
    coordinates(){
      const queryString = window.location.search;
      const urlSearchParams = new URLSearchParams(queryString);
      const [latParam, lonParam] = [urlSearchParams.get('lat'), urlSearchParams.get('lon')]
      const range = [urlSearchParams.get('range')]
      const [latitude, longitude] = (latParam !=null && lonParam !=null)
        ? [latParam, lonParam]
        : [this.geolocationPosition.coords.latitude, this.geolocationPosition.coords.longitude]
      return [latitude, longitude, range]
    },
    sorts() {
      return !this.geolocationPositionError ? this.sortOptions : this.sortOptions.filter(d => d.val !== 'distance_close')
    },
  },
  created() {
    if(!this.geolocation) return
    this.geolocation.getCurrentPosition(
      (geo) => {
        this.geolocationPosition = geo
      },
      (error) => {
        this.geolocationPositionError = error
      },
      {
        enableHighAccuracy: true,
      }
    );
  },
  mounted() {
    this.setParam()
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    onClickOutside() {
      this.popup = null
      if (JSON.stringify(this.filters) !== JSON.stringify(this.filtersComparison)) {
        this.search()
      }
    },
    togglePopup(filter) {
      if (filter === 'distance' && this.geolocationPositionError) {
        alert('位置情報を取得出来ませんでした。距離を設定する場合は位置情報サービスをオンにしてください。')
        return
      }
      this.popup = this.popup === filter ? null : filter
    },
    clear() {
      this.filters.sort_by = 'popular_coupon'
      this.filters.coupon = ''
      this.filters.budget = ['', '']
      this.filters.other = []
      this.filters.genre = []
      this.filters.area = []
      window.location.href = `${this.link}?sort_by=popular_coupon`
    },
    search() {
      const url = new URL(this.link)
      if (Object.keys(this.params).length !== 0 || this.filters) {
        if (this.params.id) {
            url.searchParams.append('id', this.params.id)
        }
        if (this.params.search_word) {
          url.searchParams.append('search_word', this.params.search_word)
        }
        if (this.params.island) {
          url.searchParams.append('island', this.params.island)
        }
        if (this.filters.sort_by) {
            url.searchParams.append('sort_by', this.filters.sort_by)
            if (this.filters.sort_by === 'distance_close') {
              url.searchParams.append('lat', this.coordinates[0])
              url.searchParams.append('lng', this.coordinates[1])
            }
        }
        if (this.filters.coupon !== '') {
          url.searchParams.append('coupon', this.filters.coupon)
        }
        if (
          this.filters.budget[0] ||
          this.filters.budget[1] ||
          this.filters.budget[2]
        ) {
          // url.searchParams.append('budgetDayOrNight', this.filters.budget[0])
          url.searchParams.append('budget_lower', this.filters.budget[0])
          url.searchParams.append('budget_upper', this.filters.budget[1])
        }
        if (this.filters.genre.length > 0) {
          url.searchParams.append('genre', this.filters.genre)
        }
        if (this.filters.other.length > 0) {
          url.searchParams.append('other', this.filters.other)
        }
        if (this.filters.area.length > 0) {
          url.searchParams.append('area', this.filters.area)
        }
        if (
          this.filters.distance[0]
        ) {
          url.searchParams.append('distance', this.filters.distance[0])
          url.searchParams.append('lat', this.coordinates[0])
          url.searchParams.append('lng', this.coordinates[1])
        }
        window.location.href = url
      }
    },
    setParam() {
      const currentUrl = window.location.href
      const urlSearchParams = new URLSearchParams(new URL(currentUrl).search)
      const coupon = urlSearchParams.get('coupon')
      // const budgetDayOrNight = urlSearchParams.get('budgetDayOrNight')
      const budgetLower = urlSearchParams.get('budget_lower')
      const budgetUpper = urlSearchParams.get('budget_upper')
      const area = urlSearchParams.get('area')
      const distance = urlSearchParams.get('distance')
      if (this.params.sort_by) {
        this.filters.sort_by = this.params.sort_by
      }
      if (coupon) {
        this.filters.coupon = JSON.parse(coupon)
      }
      // if (budgetDayOrNight) {
      //   this.filters.budget[0] = budgetDayOrNight
      // }
      if (budgetLower) {
        this.filters.budget[0] = Number(budgetLower)
      }
      if (budgetUpper) {
        this.filters.budget[1] = Number(budgetUpper)
      }
      if (this.params.genre) {
        this.filters.genre = this.params.genre.split(',').map(d => Number(d))
      }
      if (this.params.other) {
        this.filters.other = this.params.other.split(',').map(d => Number(d))
      }
      if (this.params.area) {
        this.filters.area = this.params.area.split(',').map(d => Number(d))
      }
      if (distance) {
        this.filters.distance[0] = Number(distance)
      }

      this.filtersComparison = {
        sort_by: this.filters.sort_by,
        coupon: this.filters.coupon,
        budget: [...this.filters.budget],
        genre: [...this.filters.genre],
        other: [...this.filters.other],
        area: [...this.filters.area],
        distance: [...this.filters.distance]
      }
    },
    chipTitle(targetKey='') {
      if (targetKey === 'sort') {
        if (this.filters.sort_by) {
          const result = this.sorts.find(d => d.val === this.filters.sort_by)
          return result.name
        } else {
          return '並べ替え'
        }
      }
      if (targetKey === 'coupon') {
        if (this.filters.coupon === true) {
          return 'クーポンあり'
        } else if (this.filters.coupon === false) {
          return 'クーポンなし'
        } else {
          return 'クーポン'
        }
      }
      if (targetKey === 'budget') {
        if (!this.filters.budget[0] && !this.filters.budget[1]) return '予算'
        let budgetText = ['', '']
        if (this.filters.budget[0]) {
          const lowerResult = this.budgetOptions[0].find(d => d.value === this.filters.budget[0])
          if (lowerResult) budgetText[0] = `${lowerResult.label}`
        }
        if (this.filters.budget[1]) {
          const upperResult = this.budgetOptions[1].find(d => d.value === this.filters.budget[1])
          if (upperResult) budgetText[1] = `${upperResult.label}`
        }
        return budgetText.join(" 〜 ")
      }
      if (targetKey === 'other') {
        if (this.filters.other.length > 0) {
          const result = this.tags.find(d => d.id === Number(this.filters.other[0]))
          return this.filters.other.length >= 2 ? `${result.name}、他${this.filters.other.length - 1}件` : result.name
        } else {
          return 'こだわり'
        }
      }
      if (targetKey === 'genre') {
        if (this.filters.genre.length > 0) {
          let data = []
          this.shopCategory.forEach(d => {data.push(...d.children)})
          const result = data.find(d => d.id === this.filters.genre[0])
          return this.filters.genre.length >= 2 ? `${result.name}、他${this.filters.genre.length - 1}件` : result.name
        } else {
          return 'ジャンル'
        }
      }
      if (targetKey === 'area') {
        if (this.filters.area.length > 0) {
          let data = []
          this.shopArea.forEach(d => {data.push(...d.children)})
          const result = data.find(d => d.id === this.filters.area[0])
          return this.filters.area.length >= 2 ? `${result.name}、他${this.filters.area.length - 1}件` : result.name
        } else {
          return 'エリア'
        }
      }
      if (targetKey === 'distance') {
        if (this.filters.distance[0]) {
          const result = this.distanceOptions[0].find(d => d.value === this.filters.distance[0])
          if (result) return result.label
        } else {
          return '距離'
        }
      }
    },
    summaryIsVal(key) {
        let genreNams = []
        let genreData = []
        this.shopCategory.forEach(d => {genreData.push(...d.children)})
        genreData.forEach(d => {
          if (this.filters.genre.includes(d.id)) {
            genreNams.push(d.name)
          }
        })
        if (key === 'genre') {
          if (genreNams.length > 0) {
            return genreNams.join('、 ')
          } else {
            return '指定なし'
          }
        }

        let areaNams = []
        let areaData = []
        this.shopArea.forEach(d => {areaData.push(...d.children)})
        areaData.forEach(d => {
          if (this.filters.area.includes(d.id)) {
            areaNams.push(d.name)
          }
        })
        if (key === 'area') {
          if (areaNams.length > 0) {
            return areaNams.join('、 ')
          } else {
            return '指定なし'
          }
        }

        if (key === 'selected') {
          let textList = []
          if (this.filters.sort_by) {
            const sortResult = this.sorts.find(d => d.val === this.filters.sort_by)
            textList.push(sortResult.name)
          }
          if (this.filters.coupon !== '') {
            textList.push(this.filters.coupon ? 'クーポンあり'　: 'クーポンなし')
          }

          // if (this.filters.budget[0]) {
          //   textList.push(this.filters.budget[0] === 'day' ? '昼'　: '夜')
          // }
          if (this.filters.budget[0]) {
            textList.push(`下限 $${this.filters.budget[0].toLocaleString()}`)
          }
          if (this.filters.budget[1]) {
            textList.push(`上限 $${this.filters.budget[1].toLocaleString()}`)
          }
          if (this.filters.other.length > 0) {
            let result = []
            this.tags.forEach(d => {
              if (this.filters.other.includes(d.id)) {
                result.push(d.name)
              }
            })
            textList.push(result.join('、 '))
          }
          if (genreNams.length > 0) {
            textList.push(genreNams.join('、 '))
          }
          if (areaNams.length > 0) {
            textList.push(areaNams.join('、 '))
          }
          if (this.filters.distance[0]) {
            const distanceResult = this.distanceOptions[0].find(d => d.value === this.filters.distance[0])
            if (distanceResult) {
              textList.push(distanceResult.label)
            }
          }

          return textList.join("、 ")
        }
    },
    summaryAction(key, otherId=null) {
      if (key === 'other') {
        const result = this.filters.other.find(d => d === otherId)
        if (result) {
          this.filters.other = this.filters.other.filter(d => d !== otherId)
        } else {
          this.filters.other.push(otherId)
        }
      }
      if (key === 'genre') {
        this.togglePopup('genreSummary')
      }
      if (key === 'summaryGenrePopup') {
        this.togglePopup('summary')
      }
      if (key === 'area') {
        this.togglePopup('areaSummary')
      }
      if (key === 'summaryAreaPopup') {
        this.togglePopup('summary')
      }
    },
    beforeEnter() {
      document.body.style.overflow = "hidden";
    },
    afterLeave() {
      document.body.style.overflow = "";
    }
  }
}
</script>
